<div class="container speedcheck-header" style="padding-left: 0; padding-right: 0;">
  <header class="navbar navbar-light navbar-fixed-top navbar-expand-lg">

    <button class="navbar-toggler navbar-toggler-right" type="button" (click)="navbarCollapsed = !navbarCollapsed"
            [attr.aria-expanded]="!navbarCollapsed" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse" [ngbCollapse]="navbarCollapsed" id="navbarContent">
      <ul class="navbar-nav ml-auto">

        <li class="nav-item" [routerLink]="['/']" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" [routerLink]="['/']" (click)="navbarCollapsed = true">{{ 'startButton.title' | translate }}</a>
        </li>

        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/history/.']" (click)="navbarCollapsed = true">{{ 'navbar.history' | translate}}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/settings/.']" (click)="navbarCollapsed = true">{{ 'navbar.settings' | translate}}</a>
        </li>
        <div *ngIf="isLoggedIn; then truthyTemplate else falsyTemplate"></div>
         
        <ng-template #truthyTemplate >
          <li  class="nav-item" [routerLinkActive]="['active']">
            <a class="nav-link" [routerLink]="['/logout/.']" (click)="navbarCollapsed = true">{{ 'navbar.logout' | translate}}</a>
          </li>
        </ng-template>
         
        <ng-template #falsyTemplate>
          <li class="nav-item" [routerLinkActive]="['active']">
            <a class="nav-link" [routerLink]="['/login/.']" (click)="navbarCollapsed = true">{{ 'navbar.login' | translate}}</a>
          </li>
        </ng-template>

        <li class="nav-item">
          <a class="nav-link" href="https://go.nordvpn.net/aff_c?offer_id=55&aff_id=24529&url_id=315&source=w-sc-1-nav">VPN</a>
        </li>
      </ul>
    </div>
    
  </header>
</div>